type Props = {
  className?: string;
};

const CameraIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3261 3.34773H10.8652L10.0587 2.13034C9.75435 1.67382 9.22174 1.3999 8.67391 1.3999H5.32609C4.77826 1.3999 4.24565 1.67382 3.9413 2.13034L3.13478 3.34773H1.67391C0.745652 3.34773 0 4.09338 0 5.02164V10.926C0 11.8543 0.745652 12.5999 1.67391 12.5999H12.3261C13.2543 12.5999 14 11.8543 14 10.926V5.02164C14 4.09338 13.2543 3.34773 12.3261 3.34773ZM7 11.2303C4.91522 11.2303 3.22609 9.54121 3.22609 7.45642C3.22609 5.37164 4.91522 3.69773 7 3.69773C9.08478 3.69773 10.7739 5.38686 10.7739 7.47164C10.7739 9.54121 9.08478 11.2303 7 11.2303ZM12.113 5.70642C12.0978 5.70642 12.0826 5.70642 12.0522 5.70642H11.4435C11.1696 5.69121 10.9565 5.46295 10.9717 5.18903C10.987 4.93034 11.1848 4.73251 11.4435 4.71729H12.0522C12.3261 4.70208 12.5543 4.91512 12.5696 5.18903C12.5848 5.46295 12.387 5.69121 12.113 5.70642Z"
        fill="currentColor"
      />
      <path
        d="M7.00002 5.37158C5.8435 5.37158 4.90002 6.31506 4.90002 7.47158C4.90002 8.6281 5.8435 9.55637 7.00002 9.55637C8.15654 9.55637 9.10001 8.61289 9.10001 7.45636C9.10001 6.29984 8.15654 5.37158 7.00002 5.37158Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CameraIcon;
